(function () {
    'use strict';

    a3_cabin_reports.factory('FlightSessionFactory', FlightSessionFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name FlightSessionFactory
     * @description 
     *   Add, Update, Delete and Flight Sessions.
     * @ngInject
     */
    function FlightSessionFactory(IndexedDBService, CrewRouteFactory, FlightFactory, CourseFactory, $http, apiUrl, $filter) {

        /**
         * Initialize Session
         * @memberof FlightSessionFactory
         */
        function Session() {
            this.Id = null;
        }

        var objType = 'FlightSessions';
        var objCallback = Session;

        var service = {
            getAll: getAll,
            getSession: getSession,
            setSession: setSession,
            updateSession: updateSession,
            getSessionTrainees: getSessionTrainees,
            submitSession: submitSession,
            remove: remove,
            getCrewRouteFlightTrainees : getCrewRouteFlightTrainees,
            applyTraineeInfoToSession : applyTraineeInfoToSession
        };

        /**
         * Get all flight training sessions
         * @memberof FlightSessionFactory
         * @param {function} callback  
         */
        function getAll(callback) {
            IndexedDBService.getAll(objType).then(function(results){
                callback(results);
            });
        };


        /**
         * Get session By day and courseId
         * @memberof FlightSessionFactory
         * @param {function} callback  
         */
        function getSession(courseId, day, dutyNo, dutyDay, trainingFlightIds, afterRefresh, callback, errorCallback) {
            IndexedDBService.getById(objType, [day, courseId, dutyNo, dutyDay]).then(function (session) {
                CourseFactory.getCourseFromStorage(courseId, function (course) {
                    if (course && !course.HasLimitedInfo && course.CrewCoursePhases && course.CourseTrainees) {
                        mergeCourseWithSession(course, session, dutyNo, dutyDay, trainingFlightIds, afterRefresh);
                    }
                    callback(course);
                }, errorCallback);
            })
            .catch(errorCallback);
        };


        /**
         * Remove session By day, dutyNo, dutyDay and courseId
         * @memberof FlightSessionFactory
         * @param {function} callback  
         */
        function remove(courseId, day, dutyNo, dutyDay, callback, errorCallback) {
            IndexedDBService.remove(objType, [day, courseId, dutyNo, dutyDay])
                .then(callback)
                .catch(errorCallback);
        };

        /**
        * Get session Trainees By day and courseId
        * @memberof FlightSessionFactory
        * @param {function} callback  
        */
        function getSessionTrainees(courseId, day, dutyNo, dutyDay, callback, errorCallback) {
            IndexedDBService.getById(objType, [day, courseId, dutyNo, dutyDay]).then(function (session) {
                var trainees = session && session.trainees ? session.trainees : [];
                callback(trainees);
            })
                .catch(errorCallback);
        };

        /**
        * Set session
        * @memberof FlightSessionFactory
        * @param {function} callback  
        */
        function setSession(session, callback, errorCallback) {
            IndexedDBService.getById(objType, [session.day, session.courseId, session.dutyNo, session.dutyDay]).then(function (result) {
                if (result) {
                    saveSessionToStorage(session).then(callback).catch(errorCallback);;
                } else {
                    addSessionToStorage(session).then(callback).catch(errorCallback);
                }
            }).catch(errorCallback);
        };

        /**
       * Set session
       * @memberof FlightSessionFactory
       * @param {function} callback  
       */
        function updateSession(trainees, session, courseId, day, dutyNo, dutyDay, callback, errorCallback) {
            IndexedDBService.getById(objType, [day, courseId, dutyNo, dutyDay])
                .then(function (localSession) {
                    var isNewSession = false;
                    if (!localSession) {
                        localSession = { courseId: courseId, day: day, dutyNo: dutyNo, dutyDay: dutyDay, trainees: [] }
                        isNewSession = true;
                    } else {
                        localSession.trainees = [];
                    }

                    if (session) {
                        localSession.Media = session.Media;
                        localSession.ReleasedPhase = session.ReleasedPhase;
                        localSession.PilotFunctions = session.PilotFunctions;
                        localSession.TraineeEligibilty = session.TraineeEligibilty;
                    }

                    trainees.forEach(function (trainee) {
                        localSession.trainees.push(trainee);
                    });

                    if (isNewSession) {
                        addSessionToStorage(localSession).then(callback).catch(errorCallback);
                    } else {
                        saveSessionToStorage(localSession).then(callback).catch(errorCallback);
                    }
                }).catch(errorCallback);
        }

        function mergeCourseWithSession(course, session, dutyNo, dutyDay, trainingFlightIds, afterRefresh) {
            course.HasLimitedSession = session == undefined;

            var hasPreviousSessions = mergeSyllabusWithHistory(course.CourseTrainees, course.CrewCoursePhases);
            filterTraineesByEligibility(dutyNo, dutyDay, course, trainingFlightIds, session, afterRefresh);
            
            course.CrewCoursePhases.forEach(function (phase) {
                calculatePhaseStatus(phase, course);
            });
            course.selectedPhase = getSelectedPhase(course);


            // Calculate eligible trainees phase status
            course.CourseTrainees.forEach(function (trainee) {
                var traineePhase = trainee.Phases.find(x => x.PhaseId == course.selectedPhase.PhaseId);
                if (traineePhase) {
                    trainee.ActivePhaseStatus = traineePhase.PhaseStatus;
                }
                else {
                    trainee.ActivePhaseStatus = "Pending";
                }
                trainee.Selectable = trainee.ActivePhaseStatus == "InProgress";
            });

            // Non InProgress trainees will be marked as NonEligible (remove further ahead trainees on multiple InProgress phases)
            course.CourseTrainees.filter(x => !x.Selectable).forEach(function(invalidPhaseTrainee){
                invalidPhaseTrainee.EligibilityStatus = false;
                invalidPhaseTrainee.EligibilityDesc = "AlreadySubmitted";
                course.NonEligibleTrainees.push(invalidPhaseTrainee);
            });
            course.CourseTrainees = course.CourseTrainees.filter(x => x.EligibilityStatus);
            
            // Get trainee sessions
            course.CourseTrainees.forEach(function (trainee) {
                var sessionTrainee = session ? session.trainees.find(x => x.CrewId == trainee.CrewId) : null;
                if (sessionTrainee) {
                    trainee.Session = sessionTrainee.Session;
                } else {
                    trainee.Session = {
                        Released: course.selectedPhase.ModuleType == "Training" ? false : true,
                        CrewId: trainee.CrewId,
                        Items: [],
                        Absent: false,
                        DayGrading: {
                            Comments: null,
                            Grade: null,
                            Competences: []
                        },
                        ReleaseGrading: {
                            Comments: null,
                            Grade: null,
                            Competences: []
                        },
                        NeedsAdditionalTraining: false,
                        AdditionalTrainingRemarks: null,
                        CompleteAdditionalTraining: false
                    }
                }
            });

            /*  Set default values for release option
                Training Modules: 'No' release as default
                Check Module: 'Yes' release as default
            */
            course.ReleasedPhase = course.selectedPhase.ModuleType == "Training" ? false : true;

            if (session){
                course.Media = session.Media;
                course.ReleasedPhase = session.ReleasedPhase;
                course.PilotFunctions = session.PilotFunctions;
                course.TraineeEligibilty = session.TraineeEligibilty;
            }
        }

        function getSelectedPhase(course){
            var hasSelectedPhase = false;
            var phases = course.CrewCoursePhases;

            phases.forEach(function (phase, index, array) {
                phase.isFirst = index == 0;
                phase.isLast = (index + 1 == array.length);
                // Select the first InProgress & selected phase
                if (!hasSelectedPhase && phase.Status == "InProgress" && phase.isSelected) {
                    phase.Selected = true;
                    hasSelectedPhase = true;
                }
            });
                        
            // Select the first InProgress phase
            if (!hasSelectedPhase && phases.some(x => x.Status == "InProgress")) {
                phases.find(x => x.Status == "InProgress").Selected = true;
                hasSelectedPhase = true;
            }

            if (!hasSelectedPhase) {
                phases.find(x => x.isFirst).Selected = true;
            }

            var selectedPhase = phases.find(x => x.Selected);

            return selectedPhase;
        }


        function filterTraineesByEligibility(dutyNo, dutyDay, course, trainingFlightIds, session, afterRefresh){
            // Trainee Eligiblity cases
            // 1. After refresh - Save newly fetched eligibility in session
            // 2. No refresh & Session exists - Get last fetched eligibility from session
            // 3. No refresh & No session exists - Rely on previously fetched eligibility (different duty - same course)

            var traineeEligibility = course.TraineeEligibilty;
            if(!afterRefresh && session && session.TraineeEligibilty){ 
                traineeEligibility = session.TraineeEligibilty;
            }
            if(session) session.TraineeEligibilty = traineeEligibility; //update session eligibility
            
            // Get crew route trainees without any training records
            var trainees = getCrewRouteFlightTrainees(dutyNo, dutyDay, trainingFlightIds);
            var inactiveTrainees = trainees.filter(x => !course.CourseTrainees.some(z => z.CrewId == x.CrewId));

            //Exclude Non valid trainees
            var eligibleTraineeIds = Object.keys(traineeEligibility).filter(x => traineeEligibility[x] == "NotStarted" || traineeEligibility[x] == "ValidPhase" || traineeEligibility[x] == "FailedCertificate").map(Number);
            // traineeEligibility[x] == "UnderAdditionalTraining" |
            var eligibleTrainees = inactiveTrainees.filter(x => eligibleTraineeIds.includes(x.CrewId));
            eligibleTrainees.forEach(function (trainee) { trainee.EligibilityStatus = true });
            createNewPhaseTrainees(dutyNo, dutyDay, trainingFlightIds, course, eligibleTrainees);
            
            // Merge eligibleTrainees (inactive) with CourseTrainees (eligible & active)
            course.CourseTrainees.forEach(function (trainee) { trainee.EligibilityStatus = true });
            course.CourseTrainees.push(...eligibleTrainees);
            
            // Non eligible trainees
            var nonEligibleTrainees = inactiveTrainees.filter(x => !eligibleTraineeIds.includes(x.CrewId));
            course.NonEligibleTrainees = nonEligibleTrainees;

            nonEligibleTrainees.forEach(function (trainee) {
                trainee.EligibilityStatus = false;
                trainee.EligibilityDesc = traineeEligibility[trainee.CrewId];
            });
            
            // Result:
            // CourseTrainees = eligible trainees (active or new)
            // Non EligibleTrainees
        } 

        /**
         * Create first phase foreach trainee
         * @param {object} groundDuty
         * @param {object} course
         * @param {array} trainees Eligible trainees that haven't yet started training
         */
        function createNewPhaseTrainees(dutyNo, dutyDay, trainingFlightIds, course, trainees) {
            var flights = FlightFactory.getFlightsByDutyNo(dutyNo, dutyDay).filter(f => trainingFlightIds.some(z => z == f.FlightId));
             //Match TrainingIndicators with PhaseDutyNos
             var crewCoursePhaseDutyNos = [];
             var crewrouteTrainingIndicators = [];
             course.CrewCoursePhases.forEach(function(coursePhase){
                 crewCoursePhaseDutyNos = crewCoursePhaseDutyNos.concat(coursePhase.FlightTrainingIndicators);
             });
             flights.forEach(function(flight){
                crewrouteTrainingIndicators.push(flight.TrainingIndicatorId.toString());
            });

            var relatedDutyNos = crewCoursePhaseDutyNos.filter(x => crewrouteTrainingIndicators.includes(x));
            var relatedPhases = course.CrewCoursePhases.filter(x => x.FlightTrainingIndicators.some(fti => relatedDutyNos.includes(fti)));

            //From related phases, select first in order
            relatedPhases = $filter('orderBy')(relatedPhases, 'OrderNo');
            var firstPhase = relatedPhases[0];

            trainees.forEach(function (trainee) {
                trainee.Phases = [{
                    PhaseId: firstPhase.PhaseId,
                    PhaseStatus: "InProgress",
                    RepeatRequestedItems: [],
                    isSelected: true            //selectedPhase
                }];
            })
        }

        function getCrewRouteFlightTrainees(dutyNo, dutyDay, trainingFlightIds) {
            var flights = FlightFactory.getFlightsByDutyNo(dutyNo, dutyDay).filter(f => trainingFlightIds.some(z => z == f.FlightId));
            var trainees = [];
            flights.forEach(function(flight){
                flight.crew.filter(x => x.IsTrainee).forEach(function(trainee){
                    if(!trainees.some(x => x.id == trainee.id)){ //do not push duplicates : trainees that are in multiple flights
                        trainees.push(trainee);
                    }
                });
            });

            trainees.forEach(function(trainee){
                trainee.CrewId = trainee.id;
                trainee.Id = trainee.id;
                trainee.Name = trainee.name;
                trainee.AimsId = trainee.aimsId;

            });
            return trainees;
        }

        function calculatePhaseStatus(phase, course) {
            course.CourseTrainees.forEach(function (trainee) {
                var traineePhase = trainee.Phases.find(x => x.PhaseId == phase.PhaseId);
                if (traineePhase && traineePhase.PhaseStatus == "InProgress") {
                    phase.Status = "InProgress";
                } else if (!traineePhase && phase.Status != "InProgress") {
                    phase.Status = "Pending";
                } else if (traineePhase && traineePhase.PhaseStatus == "Completed" && phase.Status != "InProgress") {
                    phase.Status = "Completed";
                }
                
                //Selected phase, If at least one trainee has it selected
                if(traineePhase && !phase.isSelected){
                    phase.isSelected = traineePhase.isSelected;
                }
            });

        }

        function mergeSyllabusWithHistory(trainees, phases) {
            var flatSullabusItems = [];
            trainees.forEach(function (trainee) {
                trainee.Phases.forEach(function (phase) {
                    phase.Sessions.forEach(function (session) {
                        session.Items.forEach(function (item) {
                            var flatItem = createFlatHistorySullabusItem(trainee, phase, session, item);
                            flatSullabusItems.push(flatItem);
                        });
                    });
                });
            });

            phases.filter(x => x.Syllabus).forEach(function (phase, index, array) {
                phase.Syllabus.SyllabusItems.forEach(function (syllabusItem) {
                    syllabusItem.History = flatSullabusItems.filter(item => item.ItemId == syllabusItem.Id);
                })
            });
            var hasPreviousSessions = flatSullabusItems.length > 0;

            return hasPreviousSessions;
        }

        function createFlatHistorySullabusItem(trainee, phase, session, item) {
            var flatItem =
            {
                CrewId: trainee.CrewId,
                PhaseId: phase.PhaseId,
                SessionId: session.SessionId,
                SessionComments: session.SessionComments,
                SubmissionDate: item.SubmissionDate,
                RepeatRequired: item.RepeatRequired,
                Tries: item.Tries,
                ItemId: item.SyllabusItemId,
                Grade: session.Grade,
                GradeType: session.GradeType,
                InstructorName: session.InstructorName,
                InstructorAimsId: session.InstructorAimsId
            };
            return flatItem;
        }

        /**
         * Add Session to Storage
         * @memberof FlightSessionFactory
         * @param {object} Session
         */
        function addSessionToStorage(session) {
            return IndexedDBService.add(objType, session);
        };

        /**
         * Update Session to Storage
         * @memberof FlightSessionFactory
         * @param {object} Session
         */
        function saveSessionToStorage(session) {
            return IndexedDBService.put(objType, session);
        };

        function submitSession(submittedSession, callback) {
            var traingingApiURL = apiUrl + '/Training/SubmitTraining';
            return $http.post(traingingApiURL, submittedSession, { 'Content-Type': 'application/json' })
                .then(callback);
        }  
  
        function applyTraineeInfoToSession(course, courseId, day, dutyNo, dutyDay, callback, errorCallback){
            IndexedDBService.getById(objType, [day, courseId, dutyNo, dutyDay])
                .then(function (localSession) {
                    var isNewSession = false;
                    if (!localSession) {
                        localSession = { 
                            courseId: courseId, 
                            day: day, 
                            dutyNo: dutyNo, 
                            dutyDay: dutyDay, 
                            trainees: [],
                            TraineeEligibilty : course.TraineeEligibilty,
                            CourseTrainees : course.CourseTrainees
                        };
                        isNewSession = true;
                    } else {
                        localSession.CourseTrainees = course.CourseTrainees;
                        localSession.TraineeEligibilty = course.TraineeEligibilty;
                    }

                    if (isNewSession) {
                        addSessionToStorage(localSession).then(callback).catch(errorCallback);
                    } else {
                        saveSessionToStorage(localSession).then(callback).catch(errorCallback);
                    }
                }).catch(errorCallback);
        }
        return service;
    }
})();
